export enum IconName {
    'add',
    'airplay',
    'all_channels',
    'all_channels_rtl',
    'all_episodes',
    'audio_subtitles',
    'back',
    'check',
    'close',
    'confirm',
    'edit',
    'enterfullscreen',
    'exitfullscreen',
    'forward_10',
    'geoblock',
    'gotolive',
    'info',
    'navigatenext',
    'navigateprev',
    'pause',
    'play',
    'quality',
    'remove',
    'restart',
    'rewind_10',
    'settings',
    'skipnext',
    'skipprev',
    'spinner',
    'subpage',
    'volume_0',
    'volume_100',
    'volume_50',
    'volume_off',
}
